

export const english = {
  welcome: 'Welcome',
  dashboard: 'Dashboard',
  Calendar: 'Calendar',
  welcomedashboard: 'welcome back!',
  Employee_Report: 'Employee Report dashboard.',
  TODAY_WORKING_HOURS: 'TODAY WORKING HOURS',
  TODAY_IDLE_HOURS: 'TODAY IDLE HOURS',
  TODAY_MOUSE_COUNT: 'TODAY MOUSE COUNT',
  TODAY_KEYS_COUNT: 'TODAY KEYS COUNT',
  User_Management: 'User Management',
  Whitelist_App: 'Whitelist App',
  Activity_Tracking: 'Activity Tracking',
  Project_Management: 'Project Management',
  Add: 'Add',
  Image: 'Image',
  Action: 'Action',
  Attendance: 'Attendance',
  Timesheet: 'Timesheet',
  Department: 'Department',
  Sub_Department: 'Sub Department',
  Sub_Department_of: 'Sub Department of',
  Role_Access: 'Access Role',
  Employee: 'Employee',
  Mouse_Keyboard: 'Mouse & Keyboard',
  Application: 'Application',
  URL: 'URL',
  Screenshots: 'Screenshots',
  Screenshot_Assignment: 'Screenshot Assignment',
  Location: 'Location',
  Projects: 'Projects',
  Client: 'Client',
  Project_Teams: 'Project Teams',
  To_Dos: 'To-dos',
  Title: 'Title',
  Share: 'Share',
  Previous: 'Previous',
  Previous_Days: 'Previous Days',
  Next: 'Next',
  Screenshot_Interval: 'Screenshot Interval',
  alert: 'are sure you want to delete',
  manual_alert: 'are sure you want to delete manual time',
  Previous_Days_Mouse_click: 'Previous Days Mouse click',
  Previous_Days_Key_Count: 'Previous Days Key Count',
  Keystroke_Count: 'Keystroke Count',
  Hours_spend_today: 'Hours spend today',
  paragraph: 'Visualize and analyze employee work hours for better time management and productivity.',
  Working_hours: ' Working hours',
  Idle_hours: ' Idle hours',
  Weekly_Report: 'Weekly Report',
  paragraph1: 'Report Status, Track your employee weekly report the basis of hours per day.',
  Manual_hours: 'Manual hours',
  Recent_screenshot: 'Recent Screenshots',
  Employee_Activity: 'Employee Activity',
  Employee_Attendence: 'Employee Attendence',
  Recent_Website: 'Recent Website',
  Department_list: 'Department List',
  Employee_List: 'Employee List',
  Upload_Extensions: 'Upload Extensions',
  Extension: 'Extension',
  Matched_Records: 'Matched Records',
  Skipped_Records: 'Skipped Records',
  Mouse_Keyboard: 'Mouse and Keyboard',
  Application_Tracking: 'Application Tracking',
  URLTrack_Activity: 'URL-Track Activity',
  Timesheet_List: 'Timesheet List',
  TimeOff: 'Time off',
  EmployeeDevice: 'Employee Device',
  Schedule: 'Schedule',
  Numbers: 'S.no',
  Dates: 'Date',
  StartTime: 'Start Time',
  INTime: 'In Time',
  OutTime: 'Out Time',
  OpenTime: 'Open Time',
  EndTime: 'End Time',
  CloseTime: 'Close Time',
  Activity: 'Activity',
  OverTime: 'Over Time',
  BreakTime: 'Break Time',
  ManualTime: 'Manual Time',
  ScreenTime: 'Screen Time',
  IdleTime: 'Idle Time',
  WorkTime: 'Active Time',
  Time: 'Time',
  OverallProduction: 'OverAll Production',
  Export: 'Export User',
  Selectfilter: 'Select filter',
  filter: 'filter',
  LeaveData: 'Leave Data',
  CurrentWeek: 'Current Week',
  WeeklyPattern: 'Weekly Pattern',
  NoData: 'No Data Found',
  LeaveHistory: 'Leave History',
  RequestLeave: 'Request Leave',
  LeaveDuration: 'Leave Duration',
  LeaveType: 'Leave Type',
  LeaveNote: 'Leave Note',
  Status: 'Status',
  ApprovedNote: 'Approved Note',
  Rating: 'Rating',
  Leave: 'Leave',
  Absent: 'Absent',
  Holiday: 'Holiday',
  WeekOf: 'Weekly Off',
  TodoList: 'Todo List',
  ToDo: 'Todo',
  OverDue: 'Overdue',
  Collapse: 'Collapse',
  Expand: 'Expand',
  Device: 'Device',
  Browser: 'Browser',
  LastVisit: 'Last Visited',
  totalUsage: 'Total Usage',
  Role_access_list: 'Access Role List',
  email: 'Email',
  phone: 'phone',
  empCode: 'Employee Code',
  DeviceId: 'Device Id',
  DeviceType: 'Device Type',
  DeviceName: 'Device Name',
  GivenName: 'Given Name',
  List: 'List',
  hoursperday: 'Hours Per day',
  TotalHours: 'Total hours',
  BreakFrom: 'Break From',
  BreakTo: 'Break To',
  clicks: 'Clicks',
  keys: 'Keys',
  CurrentLocation: 'Current location',
  selectmapType: 'Select Map Type',
  Name: 'Name',
  FirstName: 'First Name',
  LastName: 'Last Name',
  Company: 'Company',
  city: 'City',
  country: 'Country',
  Teams: 'Teams',
  yettostart: 'Yet to start',
  InProgress: 'In Progress',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
  cancel: 'Cancel',
  Total: 'Total',
  //DashBoard Page
  EffortPara: 'Effortlessly track, manage, and optimize employee activities with ease, improving productivity and collaboration across your team.',
  Yettodata: 'No Data yet!',
  Acc_act: 'Application activity not started.',
  Recent_url: 'Recently used website url',
  Track_in_out: 'Track employee IN time and OUT time',
  Span_time: 'Screenshot taken from the employee in a regular span of time',
  Hr: 'hours',
  //(department)sub_department
  sub_dept: 'Add Sub Department',
  sub_name: 'Sub Department Name',
  Enter_title: 'Enter the title',
  cls: 'Close',
  //(department) add_department
  Add_dept: 'Add Department',
  Add_name: 'Department Name',
  edit_dept: 'Edit Department',
  edit_Subdept: 'Edit Sub Department',
  //role access
  select_dept: 'Select Department',
  select_sub_dept: 'Select Sub Department',
  Create_New_Task: 'Create New Task',
  AllTask: 'All Task',
  Starred: 'Starred',
  Trash: 'Trash',
  categories: 'Categories',
  AssignedOn: 'Assigned On',
  TargetDate: 'Target Date',
  Role: 'Role',
  ReportingPerson: 'Reporting Person',
  Select_menu: 'Select Menu',
  Selected_menu: 'Selected Menu',
  Select_emp: 'Select Employee',
  Select_Department: 'Select Department',
  Select_SubDepartment: 'Select Sub Department',
  SelectRole: 'Select Role',
  SelectManager: 'Select Manager',
  SelectTeamMember: 'Select Team Member',
  close: 'Close',
  edit: 'Edit',
  Update: 'Update',
  Select: 'Select',
  enable: 'Enable',
  Password: 'Password',
  Optional: 'Optional',
  Enter: 'Enter',
  Add_Schedule: 'Add Schedule',
  Add_Emp_Schedule: 'Add Employee Schedule',
  Tasks: 'Tasks',
  Category: 'Category',
  SubCategory: 'Sub Category',
  Icon: 'Icon',
  Description: 'Description',
  Continue: 'Continue',
  StartDate: 'Start Date',
  EndDate: 'End Date',
  EstimatedHours: 'Estimated Hours',
  create: 'Create',
  Address: 'Address',
  Contact: 'Contact',
  Postal: 'Postal',
  Website: 'Website',
  Code: 'Code',
  isbillable: 'Is Billable',
  type: 'Type',
  TeamMember: 'Team Member',
  TeamManager: 'Team Manager',
  TotalCost: 'Total Cost (RO)',
  projectStatus: 'Project Status',
  notiAt: 'Notify At (RO)',
  hourRate: 'Hourly Rate (RO)',
  Project: 'Project',
  Submit: 'Submit',
  OverView: 'Overview',
  Timesheet: 'Timesheet',
  MessageBoard: 'Message board',
  Budget: 'Budget',
  cost: 'Cost',
  invest: 'Invested',
  worked: 'Worked',
  DueDate: 'Due Date',
  Enterthetitle: 'Enter the Title',
  Enterthename: 'Enter the Name',
  Enterthecode: 'Enter the Emp-Code',
  EnterDeviceName: 'Enter Device Name',
  EnterDeviceId: 'Enter Device Id',
  EnterDeviceType: 'Enter Device Type',
  EnterPassword: 'Enter Password',
  EnterPhone: 'Enter Phone Number',
  EnterGmail: 'Enter the Gmail',
  EnterScheduleName: 'Enter Schedule Name',
  EnterTotalHours: 'Enter Total Hours',
  Enter1Name: 'Enter First Name',
  EnterLastName: 'Enter Last Name',
  EnterCity: 'Enter City',
  EnterCountry: 'Enter Country',
  EnterWebsite: 'Enter Website',
  EnterCompany: 'Enter Company',
  EnterCompanyEmail: 'Enter Company Email',
  EnterCompanyContact: 'Enter Company Contact',
  EnterPostal: 'Enter Postal Code',
  EnterCompanyAddress: 'Enter Company Address',
  EnterDescription: 'Enter the description',
  EnterHourRate: 'Enter Hour Rate',
  EnterBudgetInvest: 'Budget Invested',
  EnterTotalCost: 'Enter Total Cost',
  SelectStatus: 'Select Status',
  EnterHour: 'Enter the Hours',
  SearchForAnything: 'Search for anything ....',
  Search: 'Search',
  Remaininghours: 'Remaining hours',
  Spenthours: 'Spent hours',
  details: 'Details',
  EnterEstimated: 'Enter Estimated hours',
  EnterCategory: 'Enter the Category',
  EnterSubCat: 'Enter Sub Category',
  SignInWfm: 'Sign in to Kafaa Employee',
  SignInAdminWfm: 'Sign in to Kafaa Admin',
  pleaseLogintocontinue: 'Please login to continue',
  submit: 'Submit',
  orloginwithadmin: 'Or login with admin',
  orloginwithEmployee: 'Or login with employee',
  workforcemanagement: 'Kafaa',
  TrackandReport: 'Track and Report your activity',
  loginDesc: 'Activity Tracking involves monitoring and recording tasks and behaviors over time to analyze productivity, habits, or progress.',
  checkout: 'Check Out our Web app',
  donthaveaccount: "Don't have an account? Create an account",
  From_time: "From Date/Time",
  To_time: "To Date/Time",
  New_Event: "New Event",
  Edit_Event: "Edit Event",
  ADD_Event: "Add Event",
  AddDevice: 'Add New Device',
  UpdateDevice: 'Update Device',
  Events: "Event",
  Dashboard: "Dashboard",
  save_event: "Save Event",
  Calendar: "Calendar",
  PendingDevice: "Pending Device",
  PendingDeviceList: "Pending Device List",
  condevice: 'Configured Device',
  DeviceID: "Device ID",
  EnterGmailusername: 'Enter email or username',
  SelectedReportingPerson: 'Selected Reporting Person',
  knowlegeTransfer: 'Knowlege Transfer',
  TaskAssign: 'Task Assign',
  TaskTitle: 'Task Title',
  Amount: 'Amount',
  Author: 'Author',
  PostedDateTime: 'Posted Date & Time',
  Views: 'Views',
  writeReview: 'Write a review',
  Review: 'Review',
  howexpericence: 'How was your experience?',
  Post: 'Post',
  writtenby: 'Written By',
  Uploadfile: 'Upload File',
  Uploadedfile: 'Uploaded File',
  logoutalert: 'You will be logged out of your account!',
  yeslogout: 'Yes, Log out',
  Time_Interval: 'Time Interval',
  Time_Type: 'Time Type',
  Screen_Interval_List: 'Screen Interval List',
  Add_Screen_Interval: ' Add Screen Interval',
  Edit_Screen_Interval: 'Edit Screen Interval',
  Minutes: 'Minutes',
  Delete: 'Delete',
  OverAllTime: 'Over All Time',
  Sub_Category_of: 'Sub Category Of',
  View: 'View',
  EmployeeLog: 'Employee Log',
  Keystroke: 'Keystroke',
  Mouse_Click: 'Mouse Click',
  Select_An_Option: 'Select An Option',
  casenumber: 'Case Number',
  urltrack: 'URL Track',
  confirmpassword: 'Confirm Password',
  Tracking: 'Tracking',
  Sync_Employees: 'Sync Employees',
  Report: 'Report',
  Project_Report: 'Project Report',
  Overall_Report: 'Overall Report',
  Task_Tracking: 'Task Tracking',
  Case_Tracking: 'Case Tracking',
  Reports: 'Reports',
  Download_KAFAA: 'Download KAFAA.exe',
  ConfiguredDevice: 'Configured Device',
  Overall_Employee_Report: 'Overall Employee Report',
  Employee_Work_Performance: 'Employee Work Performance',
  From_Date: 'From Date',
  To_Date: 'To Date',
  Apply_Filters: 'Apply Filters',
  All_Performance: 'All Performance',
  Days_Recorded: 'Days Recorded',
  Sum_Scheduled_Hours: 'Sum Scheduled Hours',
  Sum_Worked_Hours: 'Sum Worked Hours',
  Sum_Manual_Hours: 'Sum Manual Hours',
  Sum_Incomplete_Hours: 'Sum Incomplete Hours',
  Sum_Extra_Hours: 'Sum Extra Hours',
  Export_PDF: 'Export PDF',
  Are_you_sure: 'Are you sure?',
  Enter_Current_Password: 'Enter Current Password',
  Current_Password_Required: 'Current password required',
  Password_Updated_Success: 'Password updated successfully',
  Something_went_wrong: 'Something went wrong',
  Timesheets: 'Timesheets',
  Message_Board: 'Message Board',
  Client_Request: 'Client Request',
  Financial_Overview: 'Financial Overview',
  RemainingAmount: 'Remaining Amount',
  SpentAmount: 'Spent Amount',
  Hours_Overview: 'Hours Overview',
  Budget_Usage: 'Budget Usage',
  of_Budget_Used: 'of Budget Used',
  No_Description_Available: 'No Description Available',
  Top_Performers: 'Top Performers',
  Tasks_List: 'Tasks List',
  Bulk_Upload: 'Bulk Upload',
  Manual: 'Manual',
  From: 'From',
  To: 'To',
  Search_employee: 'Search employee...',
  All: 'All',
  Reset: 'Reset',
  Date: 'Date',
  Billable: 'Billable',
  Yes: 'Yes',
  No: 'No',
  Employee_Summary: 'Employee Summary',
  Sessions: 'Sessions',
  Confirm: 'Confirm',
  Update_Status_Confirm: 'Are you sure you want to update the status?',
  Delete_Task_Confirm: 'You want to delete this task?',
  Load_Older_Messages: 'Load Older Messages',
  Loading: 'Loading...',
  Update_Project_Status_Confirm: 'Update Project Status?',
  Change: 'Change',
  Days: 'Days',
  Page: 'Page',
  Performance: 'Performance',
  EndTime: 'End Time',
  StartTime: 'Start Time',
  PBX_Management: 'PBX Management',
  PBX_Dashboard: 'PBX Dashboard',
  My_Extension: 'My Extension',
  Call_History_CDR: 'Call History (CDR)',
  Active_Calls: 'Active Calls',
  Extensions: 'Extensions',
  Call_Forwarding: 'Call Forwarding',
  Inbound_Routes: 'Inbound Routes',
  Outbound_Routes: 'Outbound Routes',
  Ring_Groups: 'Ring Groups',
  Queues: 'Queues',
  PBX_Dashboard_Title: 'PBX Management Dashboard',
  PBX_Dashboard_Subtitle: 'Real-time telecommunication overview, active line metrics & system call stats',
  Today: 'Today',
  Last_7_Days: 'Last 7 Days',
  This_Month: 'This Month',
  Custom_Date_Range: 'Custom Date Range',
  Start: 'Start',
  End: 'End',
  Apply_Filter: 'Apply Filter',
  Total_Extensions: 'Total Extensions',
  Registered_Extensions: 'Registered Extensions',
  Active_Calls: 'Active Calls',
  Todays_Calls: "Today's Calls",
  Answered_Calls: 'Answered Calls',
  Missed_Calls: 'Missed Calls',
  Failed_Calls: 'Failed Calls',
  Avg_Call_Duration: 'Avg Call Duration',
  Configured_SIP_extensions: 'Configured SIP extensions',
  online: 'online',
  Live_ongoing_calls: 'Live ongoing calls',
  Total_processed_today: 'Total processed today',
  Successful_connections: 'Successful connections',
  Unanswered_calls: 'Unanswered calls',
  System_Trunk_errors: 'System / Trunk errors',
  Average_length_per_call: 'Average length per call',
  Calls_per_Hour: 'Calls per Hour',
  Calls_by_Status: 'Calls by Status',
  Top_Extension_Volume: 'Top Extension Volume',
  Recent_Calls_Log: 'Recent Calls Log',
  Call_ID: 'Call ID',
  Caller: 'Caller',
  Callee: 'Callee',
  Direction: 'Direction',
  Duration: 'Duration',
  Actions: 'Actions',
  Start_Time: 'Start Time',
  End_Time: 'End Time',
  Extension: 'Extension',
  Trunk: 'Trunk',
  Active_Calls_Subtitle: 'Monitor live PBX calls, manage active sessions, transfer or hangup calls in real-time',
  No_live_active_calls: 'No live active calls at the moment.',
  State: 'State',
  PBX_Extensions_Title: 'PBX Extensions',
  PBX_Extensions_Subtitle: 'Manage user SIP extensions, status, registration details & departamental routing',
  Add_Extension: 'Add Extension',
  Registration_Status: 'Registration Status',
  Registration: 'Registration',
  Email: 'Email',
  Call_Forward: 'Call Forward',
  Enable_Disable: 'Enable/Disable',
  Call_Forwarding_Subtitle: 'Configure rule conditions (Always, Busy, No Answer, Unavailable) and target routing per extension',
  Forward_Type: 'Forward Type',
  Forward_Number: 'Forward Number',
  Inbound_Routes_Subtitle: 'Manage DID patterns, inbound destination rules (IVR, Queues, Extensions), and execution priorities',
  Add_Inbound_Route: 'Add Inbound Route',
  Route_Name: 'Route Name',
  DID_Pattern: 'DID / Pattern',
  Destination_Target: 'Destination Target',
  Priority: 'Priority',
  Outbound_Routes_Subtitle: 'Manage dial patterns, assigned SIP trunks, caller ID overrides & outbound dialing priorities',
  Add_Outbound_Route: 'Add Outbound Route',
  Route: 'Route',
  Dial_Pattern: 'Dial Pattern',
  SIP_Trunk: 'SIP Trunk',
  Ring_Groups_Subtitle: 'Group multiple extension endpoints to ring simultaneously or sequentially',
  Add_Ring_Group: 'Add Ring Group',
  Group_Name: 'Group Name',
  Members: 'Members',
  Ring_Strategy: 'Ring Strategy',
  Call_Queues_Title: 'Call Queues',
  Call_Queues_Subtitle: 'ACD Queues management, agent assignments, dispatch strategies & live waiting calls',
  Add_Queue: 'Add Queue',
  Queue_Number: 'Queue Number',
  Queue_Name: 'Queue Name',
  Assigned_Agents: 'Assigned Agents',
  Strategy: 'Strategy',
  Waiting_Calls: 'Waiting Calls',
  Call_Recordings: 'Call Recordings',
  Call_Recordings_Subtitle: 'Listen to stored audio logs, download WAV/MP3 files, manage storage retention',
  Recording_Name: 'Recording Name',
  Receiver: 'Receiver',
  Date_Time: 'Date & Time',
  File_Size: 'File Size',
  Play_Recording: 'Play Recording',
  Delete_File: 'Delete File',
  Delete_Call_Recording: 'Delete Call Recording?',
  Delete_Recording_Confirm: 'Are you sure you want to permanently delete the recording file?',
  Delete_Inbound_Route: 'Delete Inbound Route?',
  Delete_Inbound_Route_Confirm: 'Are you sure you want to remove this inbound route?',
  Delete_Outbound_Route: 'Delete Outbound Route?',
  Delete_Outbound_Route_Confirm: 'Are you sure you want to remove this outbound route?',
  Delete_Ring_Group: 'Delete Ring Group?',
  Delete_Ring_Group_Confirm: 'Are you sure you want to remove this ring group?',
  Delete_Call_Queue: 'Delete Call Queue?',
  Delete_Call_Queue_Confirm: 'Are you sure you want to remove this queue?',
  Edit_Extension: 'Edit Extension',
  Add_New_Extension: 'Add New Extension',
  Extension_Number: 'Extension Number',
  Full_Name: 'Full Name',
  Email_Address: 'Email Address',
  SIP_Secret: 'SIP Secret / Password',
  Save_Extension: 'Save Extension',
  Edit_Call_Forwarding: 'Edit Call Forwarding',
  Forward_Target_Number: 'Forward Target / Number',
  Enable_Forwarding_Rule: 'Enable Forwarding Rule',
  Save_Rule: 'Save Rule',
  Edit_Inbound_Route: 'Edit Inbound Route',
  Save_Route: 'Save Route',
  Edit_Outbound_Route: 'Edit Outbound Route',
  Edit_Ring_Group: 'Edit Ring Group',
  Select_Extension_Members: 'Select Extension Members:',
  Group_Extension: 'Group Extension',
  Save_Group: 'Save Group',
  Edit_Call_Queue: 'Edit Call Queue',
  Assign_Extension_Agents: 'Assign Extension Agents:',
  Save_Queue: 'Save Queue',
  Transfer_Active_Call: 'Transfer Active Call',
  Transferring_call_from: 'Transferring call from',
  to_target_extension: 'to target extension.',
  Target_Extension_Number: 'Target Extension Number',
  Transfer_Call: 'Transfer Call',
  Call_Detail: 'Call Detail',
  Recording: 'Recording',
  No_Recording: 'No Recording',
  Test_PBX_Connection: 'Test PBX Connection',
  Refresh: 'Refresh',
  Export_CSV: 'Export CSV',
  Add_New: 'Add New',
  Clear: 'Clear',
  Search_Placeholder: 'Search...',
  Confirm_Action: 'Confirm Action',
  Processing: 'Processing...',
  Registered: 'Registered',
  Unregistered: 'Unregistered',
  Always: 'Always',
  Busy: 'Busy',
  No_Answer: 'No Answer',
  Unavailable: 'Unavailable',
  RingAll: 'RingAll (Simultaneous)',
  Hunt: 'Hunt (Sequential)',
  Memory: 'Memory (Round Robin)',
  LeastRecent: 'Least Recent',
  Random: 'Random',
  FewestCalls: 'Fewest Calls',
  Agents: 'Agents',
  Waiting: 'Waiting',
  On: 'On',
  Off: 'Off',
  Answered: 'Answered',
  Missed: 'Missed',
  Failed: 'Failed',
  Last_7_Days_Calls: 'Last 7 Days Calls',
  This_Month_Calls: 'This Month Calls',
  Period_Calls: 'Period Calls',
  Total_processed_7days: 'Total processed in last 7 days',
  Total_processed_month: 'Total processed this month',
  Total_processed_period: 'Total processed in selected range',
};

export const arabic = {
  welcome: 'مرحبًا',
  dashboard: 'لوحة التحكم',
  welcomedashboard: 'مرحبًا بعودتك!',
  Employee_Report: 'لوحة تقرير الموظف',
  TODAY_WORKING_HOURS: 'ساعات العمل اليوم',
  TODAY_IDLE_HOURS: 'ساعات الفراغ اليوم',
  TODAY_MOUSE_COUNT: 'نقرة الماوس',
  TODAY_KEYS_COUNT: 'اليوم، المفاتيح مهمة',
  Whitelist_App: 'تطبيق القائمة البيضاء',
  User_Management: 'إدارة المستخدم',
  Activity_Tracking: 'تتبع النشاط',
  Project_Management: 'إدارة المشاريع',
  Add: 'إضافة',
  Share: 'مشاركة',
  Action: 'الإجراء',
  Attendance: 'الحضور',
  Timesheet: 'جدول العمل',
  Department: 'القسم',
  Sub_Department: 'القسم الفرعي',
  Sub_Department_of: 'القسم الفرعي للموارد البشرية',
  Role_Access: 'دور الوصول',
  Employee: 'الموظف',
  Mouse_Keyboard: 'الفأرة ولوحة المفاتيح',
  Application: 'التطبيق',
  URL: 'الرابط',
  Screenshots: 'لقطات الشاشة',
  Screenshot_Assignment: 'تعيين لقطات الشاشة',
  Location: 'الموقع',
  Projects: 'المشاريع',
  Client: 'العميل',
  Project_Teams: 'فرق المشاريع',
  To_Dos: 'المهام',
  Title: 'العنوان',
  Previous: 'السابق',
  Next: 'التالي',
  Previous_Days: 'الأيام السابقة',
  Previous_Days_Mouse_click: 'نقرة الماوس في الأيام السابقة',
  Previous_Days_Key_Count: 'عدد المفاتيح في الأيام السابقة',
  Keystroke_Count: 'عدد الضغطات',
  Hours_spend_today: 'الساعات التي قضاها اليوم',
  paragraph: 'تصور وحلل ساعات عمل الموظفين لتحسين إدارة الوقت والإنتاجية.',
  Working_hours: 'ساعات العمل',
  Idle_hours: 'ساعات الخمول',
  Weekly_Report: 'التقرير الأسبوعي',
  paragraph1: 'حالة التقرير، تتبع التقرير الأسبوعي لموظفيك بناءً على الساعات اليومية.',
  Manual_hours: 'الساعات اليدوية',
  Recent_screenshot: 'لقطات الشاشة الأخيرة',
  Employee_Activity: 'نشاط الموظف',
  Employee_Attendence: 'حضور الموظف',
  Recent_Website: 'الموقع الإلكتروني الأخير',
  Department_list: 'قائمة الأقسام',
  Employee_List: 'قائمة الموظفين',
  Upload_Extensions: 'رفع دليل التحويلات',
  Extension: 'رقم المحول',
  Matched_Records: 'السجلات المتطابقة',
  Skipped_Records: 'السجلات المتخطاة',
  Mouse_Keyboard: 'الفأرة ولوحة المفاتيح',
  Application_Tracking: 'تتبع التطبيقات',
  URLTrack_Activity: 'تتبع الروابط',
  Timesheet_List: 'قائمة الجداول الزمنية',
  TimeOff: 'وقت الراحة',
  EmployeeDevice: 'جهاز الموظف',
  Schedule: 'الجدول',
  Numbers: 'رقم',
  Dates: 'التاريخ',
  StartTime: 'وقت البدء',
  INTime: 'وقت الدخول',
  OutTime: 'وقت الخروج',
  Rating: 'التقييم',
  OpenTime: 'وقت الفتح',
  EndTime: 'وقت النهاية',
  CloseTime: 'وقت الإغلاق',
  Activity: 'النشاط',
  OverTime: 'العمل الإضافي',
  BreakTime: 'وقت الاستراحة',
  ManualTime: 'الوقت اليدوي',
  ScreenTime: 'وقت الشاشة',
  IdleTime: 'وقت الخمول',
  WorkTime: 'وقت العمل',
  Time: 'الوقت',
  OverallProduction: 'إجمالي الإنتاجية',
  Export: 'تصدير المستخدم',
  Selectfilter: 'اختر الفلتر',
  filter: 'الفلتر',
  LeaveData: 'بيانات الإجازة',
  CurrentWeek: 'الأسبوع الحالي',
  WeeklyPattern: 'النمط الأسبوعي',
  NoData: 'لا توجد بيانات',
  LeaveHistory: 'تاريخ الإجازات',
  RequestLeave: 'طلب إجازة',
  LeaveDuration: 'مدة الإجازة',
  LeaveType: 'نوع الإجازة',
  LeaveNote: 'ملاحظة الإجازة',
  Status: 'الحالة',
  ApprovedNote: 'ملاحظة الموافقة',
  Leave: 'إجازة',
  Absent: 'غياب',
  Holiday: 'عطلة',
  Image: 'صورة',
  WeekOf: 'إجازة أسبوعية',
  TodoList: 'قائمة المهام',
  ToDo: 'قائمة المهام',
  OverDue: 'متأخر',
  Collapse: 'طي',
  Expand: 'توسيع',
  Device: 'الجهاز',
  Browser: 'المتصفح',
  LastVisit: 'آخر زيارة',
  totalUsage: 'إجمالي الاستخدام',
  Role_access_list: 'الوصول إلى قائمة الأدوار',
  email: 'البريد الإلكتروني',
  phone: 'الهاتف',
  empCode: 'رمز الموظف',
  DeviceId: 'معرف الجهاز',
  DeviceType: 'نوع الجهاز',
  DeviceName: 'اسم الجهاز',
  GivenName: 'الاسم المعطى',
  List: 'القائمة',
  hoursperday: 'ساعات في اليوم',
  TotalHours: 'إجمالي الساعات',
  BreakFrom: 'استراحة من',
  BreakTo: 'استراحة إلى',
  clicks: 'النقرات',
  keys: 'الضغطات',
  CurrentLocation: 'الموقع الحالي',
  selectmapType: 'اختر نوع الخريطة',
  manual_alert: 'هل أنت متأكد من رغبتك في حذف الوقت اليدوي؟',
  Name: 'الاسم',
  FirstName: 'الاسم الأول',
  LastName: 'اسم العائلة',
  Company: 'الشركة',
  city: 'المدينة',
  country: 'الدولة',
  Teams: 'الفرق',
  yettostart: 'لم يبدأ بعد',
  InProgress: 'قيد التنفيذ',
  Completed: 'مكتمل',
  Cancelled: 'ملغى',
  cancel: 'إلغاء',
  Total: 'الإجمالي',
  EffortPara: 'تابع وأدر نشاطات الموظفين بكل سهولة لتحسين الإنتاجية والتعاون في فريقك.',
  Yettodata: 'لا توجد بيانات حتى الآن!',
  Acc_act: 'نشاط التطبيق لم يبدأ بعد.',
  Recent_url: 'الرابط الأخير المستخدم',
  Track_in_out: 'تتبع وقت دخول وخروج الموظف',
  Span_time: 'لقطة الشاشة تم التقاطها في فترات زمنية منتظمة',
  Hr: 'ساعات',
  sub_dept: 'إضافة قسم فرعي',
  sub_name: 'اسم القسم الفرعي',
  Enter_title: 'أدخل العنوان',
  cls: 'إغلاق',
  Add_dept: 'إضافة قسم',
  Add_name: 'اسم القسم',
  edit_dept: 'تحرير القسم',
  edit_Subdept: 'القسم الفرعي',
  select_dept: 'اختر القسم',
  select_sub_dept: 'اختر القسم الفرعي',
  Create_New_Task: 'إنشاء مهمة جديدة',
  AllTask: 'كل المهام',
  Starred: 'المفضلة',
  Trash: 'المهملات',
  categories: 'الفئات',
  AssignedOn: 'تم التعيين في',
  TargetDate: 'تاريخ الهدف',
  Role: 'الدور',
  Select_menu: 'اختر القائمة',
  Selected_menu: 'القائمة المختارة',
  Select_emp: 'اختر الموظف',
  Select_Department: 'اختر القسم',
  Select_SubDepartment: 'اختر القسم الفرعي',
  SelectRole: 'اختر الدور',
  SelectManager: 'اختر المدير',
  SelectTeamMember: 'اختر عضو الفريق',
  close: 'إغلاق',
  edit: 'تحرير',
  Update: 'تحديث',
  Select: 'اختر',
  enable: 'تمكين',
  Password: 'كلمة المرور',
  Optional: 'اختياري',
  Enter: 'أدخل',
  Add_Schedule: 'إضافة جدول',
  Add_Emp_Schedule: 'إضافة جدول الموظف',
  Tasks: 'المهام',
  Category: 'فئة',
  SubCategory: 'الفئة الفرعية',
  Icon: 'أيقونة',
  Description: 'الوصف',
  Continue: 'استمر',
  StartDate: 'تاريخ البدء',
  EndDate: 'تاريخ الانتهاء',
  EstimatedHours: 'الساعات المقدرة',
  create: 'إنشاء',
  Address: 'العنوان',
  Contact: 'الاتصال',
  Postal: 'البريد',
  Website: 'الموقع الإلكتروني',
  Code: 'الرمز',
  isbillable: 'قابل للفوترة',
  type: 'النوع',
  TeamMember: 'عضو الفريق',
  TeamManager: 'مدير الفريق',
  TotalCost: 'التكلفة الإجمالية',
  projectStatus: 'حالة المشروع',
  notiAt: 'إشعار في',
  hourRate: 'معدل الساعة',
  Project: 'مشروع',
  Submit: 'إرسال',
  OverView: 'نظرة عامة',
  Timesheet: 'الجدول الزمني',
  MessageBoard: 'لوحة الرسائل',
  Budget: 'الميزانية',
  cost: 'التكلفة',
  invest: 'مستثمر',
  worked: 'عمل',
  DueDate: 'تاريخ الاستحقاق',
  Enterthetitle: 'أدخل العنوان',
  Enterthename: 'أدخل الاسم',
  Enterthecode: 'أدخل رمز الموظف',
  EnterDeviceName: 'أدخل اسم الجهاز',
  EnterDeviceId: 'أدخل معرف الجهاز',
  EnterDeviceType: 'أدخل نوع الجهاز',
  EnterPassword: 'أدخل كلمة المرور',
  EnterPhone: 'أدخل رقم الهاتف',
  EnterGmail: 'أدخل بريد الجيميل',
  EnterScheduleName: 'أدخل اسم الجدول',
  EnterTotalHours: 'أدخل إجمالي الساعات',
  Enter1Name: 'أدخل الاسم الأول',
  EnterLastName: 'أدخل اسم العائلة',
  EnterCity: 'أدخل المدينة',
  EnterCountry: 'أدخل الدولة',
  EnterWebsite: 'أدخل الموقع الإلكتروني',
  EnterCompany: 'أدخل اسم الشركة',
  EnterCompanyEmail: 'أدخل بريد الشركة',
  EnterCompanyContact: 'أدخل جهة اتصال الشركة',
  EnterPostal: 'أدخل الرمز البريدي',
  EnterCompanyAddress: 'أدخل عنوان الشركة',
  EnterDescription: 'أدخل الوصف',
  EnterHourRate: 'أدخل سعر الساعة',
  EnterBudgetInvest: 'الميزانية المستثمرة',
  EnterTotalCost: 'أدخل التكلفة الإجمالية',
  SelectStatus: 'اختر الحالة',
  EnterHour: 'أدخل الساعات',
  SearchForAnything: 'ابحث عن أي شيء....',
  Search: 'بحث',
  Remaininghours: 'الساعات المتبقية',
  Spenthours: 'الساعات المستهلكة',
  details: 'التفاصيل',
  EnterEstimated: 'أدخل الساعات المقدرة',
  EnterCategory: 'أدخل الفئة',
  EnterSubCat: 'أدخل الفئة الفرعية',
  SignInWfm: 'تسجيل الدخول إلى موظف كفاءة',
  SignInAdminWfm: 'تسجيل الدخول إلى إدارة كفاءة',
  pleaseLogintocontinue: 'يرجى تسجيل الدخول للمتابعة',
  submit: 'إرسال',
  orloginwithadmin: 'أو تسجيل الدخول كمسؤول',
  orloginwithEmployee: 'أو تسجيل الدخول كموظف',
  workforcemanagement: 'كفاءة',
  TrackandReport: 'تتبع وأبلغ عن نشاطك',
  loginDesc: 'تتبع النشاط يتضمن مراقبة وتسجيل المهام والسلوكيات على مدار الوقت لتحليل الإنتاجية والعادات أو التقدم.',
  checkout: 'تحقق من تطبيق الويب الخاص بنا',
  donthaveaccount: 'ليس لديك حساب؟ أنشئ حسابًا',
  From_time: "من التاريخ/الوقت",
  To_time: "إلى التاريخ/الوقت",
  New_Event: "حدث جديد",
  Edit_Event: "تحرير الحدث",
  ADD_Event: "أضف حدثًا",
  AddDevice: 'إضافة جهاز جديد',
  UpdateDevice: 'تحديث الجهاز',
  Events: "حدث",
  Dashboard: "لوحة القيادة",
  save_event: "حفظ الحدث",
  Calendar: "تقويم",
  PendingDevice: "الجهاز المعلق",
  PendingDeviceList: "قائمة الأجهزة المعلقة",
  condevice: 'الجهاز المُكوَّن',
  DeviceID: "Device ID",
  EnterGmailusername: "أدخل البريد الإلكتروني أو اسم المستخدم",
  ReportingPerson: 'الشخص المُبلِّغ',
  SelectedReportingPerson: 'الشخص المسؤول المختار',
  knowlegeTransfer: 'نقل المعرفة',
  TaskAssign: 'إسناد المهام',
  TaskTitle: 'عنوان المهمة',
  Amount: 'المبلغ',
  Author: 'المؤلف',
  PostedDateTime: 'تاريخ ووقت النشر',
  Views: 'المشاهدات',
  writeReview: 'اكتب تقييمًا',
  Review: 'تقييم',
  howexpericence: 'كيف كانت تجربتك؟',
  Post: 'منشور',
  writtenby: 'كتبه',
  Uploadfile: 'تحميل ملف',
  Uploadedfile: 'الملف المحمَّل',
  logoutalert: 'سيتم تسجيل خروجك من حسابك!',
  yeslogout: 'نعم، تسجيل الخروج',
  Screenshot_Interval: 'الفاصل الزمني للقطة الشاشة',
  Time_Interval: 'الفاصل الزمني',
  Time_Type: 'نوع الوقت',
  Screen_Interval_List: 'قائمة الفاصل الزمني للشاشة',
  Add_Screen_Interval: 'إضافة الفاصل الزمني للشاشة',
  Edit_Screen_Interval: 'تحرير الفاصل الزمني للشاشة',
  Minutes: 'دقائق  ',
  Delete: 'يمسح',
  alert: 'متأكد أنك تريد الحذف',
  OverAllTime: 'في كل الأوقات',
  Sub_Category_of: 'الفئة الفرعية',
  View: 'منظر',
  EmployeeLog: 'سجل الموظفين',
  Keystroke: 'ضغطة المفتاح',
  Mouse_Click: 'انقر بالماوس',
  Select_An_Option: 'حدد خيارًا',
  casenumber: 'رقم القضية',
  urltrack: 'تتبع الرابط',
  confirmpassword: 'تأكيد كلمة المرور',
  Tracking: 'التتبع',
  Sync_Employees: 'مزامنة الموظفين',
  Report: 'التقرير',
  Project_Report: 'تقرير المشروع',
  Overall_Report: 'التقرير العام',
  Task_Tracking: 'تتبع المهام',
  Case_Tracking: 'تتبع الحالات',
  Reports: 'التقارير',
  Download_KAFAA: 'تحميل كفاءة',
  ConfiguredDevice: 'الجهاز المُكوَّن',
  Overall_Employee_Report: 'تقرير الموظف العام',
  Employee_Work_Performance: 'أداء عمل الموظف',
  From_Date: 'من تاريخ',
  To_Date: 'إلى تاريخ',
  Apply_Filters: 'تطبيق الفلاتر',
  All_Performance: 'كل الأداء',
  Days_Recorded: 'الأيام المسجلة',
  Sum_Scheduled_Hours: 'مجموع الساعات المقررة',
  Sum_Worked_Hours: 'مجموع ساعات العمل',
  Sum_Manual_Hours: 'مجموع الساعات اليدوية',
  Sum_Incomplete_Hours: 'مجموع الساعات غير المكتملة',
  Sum_Extra_Hours: 'مجموع الساعات الإضافية',
  Export_PDF: 'تصدير PDF',
  Are_you_sure: 'هل أنت متأكد؟',
  Enter_Current_Password: 'أدخل كلمة المرور الحالية',
  Current_Password_Required: 'كلمة المرور الحالية مطلوبة',
  Password_Updated_Success: 'تم تحديث كلمة المرور بنجاح',
  Something_went_wrong: 'حدث خطأ ما',
  Timesheets: 'الجداول الزمنية',
  Message_Board: 'لوحة الرسائل',
  Client_Request: 'طلب عميل',
  Financial_Overview: 'نظرة عامة مالية',
  RemainingAmount: 'المبلغ المتبقي',
  SpentAmount: 'المبلغ المنفق',
  Hours_Overview: 'نظرة عامة على الساعات',
  Budget_Usage: 'استخدام الميزانية',
  of_Budget_Used: 'من الميزانية المستخدمة',
  No_Description_Available: 'لا يوجد وصف متاح',
  Top_Performers: 'الأفضل أداءً',
  Tasks_List: 'قائمة المهام',
  Bulk_Upload: 'تحميل جماعي',
  Manual: 'يدوي',
  From: 'من',
  To: 'إلى',
  Search_employee: 'بحث عن موظف...',
  All: 'الكل',
  Reset: 'إعادة ضبط',
  Date: 'التاريخ',
  Billable: 'قابل للفوترة',
  Yes: 'نعم',
  No: 'لا',
  Employee_Summary: 'ملخص الموظف',
  Sessions: 'الجلسات',
  Confirm: 'تأكيد',
  Update_Status_Confirm: 'هل أنت متأكد أنك تريد تحديث الحالة؟',
  Delete_Task_Confirm: 'هل تريد حذف هذه المهمة؟',
  Load_Older_Messages: 'تحميل الرسائل القديمة',
  Loading: 'جارٍ التحميل...',
  Update_Project_Status_Confirm: 'هل تريد تحديث حالة المشروع؟',
  Change: 'تغيير',
  Days: 'أيام',
  Page: 'صفحة',
  Performance: 'الأداء',
  PBX_Management: 'إدارة البدالة (PBX)',
  PBX_Dashboard: 'لوحة تحكم البدالة',
  My_Extension: 'تحويلتي الداخلية',
  Call_History_CDR: 'سجل المكالمات (CDR)',
  Active_Calls: 'المكالمات النشطة',
  Extensions: 'التحويلات الداخلية',
  Call_Forwarding: 'تحويل المكالمات',
  Inbound_Routes: 'الخطوط الواردة',
  Outbound_Routes: 'الخطوط الصادرة',
  Ring_Groups: 'مجموعات الاتصال',
  Queues: 'طوابير الانتظار',
  PBX_Dashboard_Title: 'لوحة تحكم البدالة',
  PBX_Dashboard_Subtitle: 'نظرة عامة على الاتصالات في الوقت الفعلي، ومقاييس الخطوط النشطة وإحصاءات المكالمات',
  Today: 'اليوم',
  Last_7_Days: 'آخر 7 أيام',
  This_Month: 'هذا الشهر',
  Custom_Date_Range: 'مخصص',
  Start: 'البداية',
  End: 'النهاية',
  Apply_Filter: 'تطبيق الفلتر',
  Total_Extensions: 'إجمالي التحويلات',
  Registered_Extensions: 'التحويلات النشطة',
  Active_Calls: 'المكالمات النشطة',
  Todays_Calls: 'مكالمات اليوم',
  Answered_Calls: 'المكالمات المجابة',
  Missed_Calls: 'المكالمات الفائتة',
  Failed_Calls: 'المكالمات الفاشلة',
  Avg_Call_Duration: 'معدل مدة المكالمة',
  Configured_SIP_extensions: 'التحويلات التي تم تكوينها',
  online: 'نشط',
  Live_ongoing_calls: 'المكالمات المباشرة الجارية',
  Total_processed_today: 'إجمالي مكالمات اليوم',
  Successful_connections: 'اتصالات ناجحة',
  Unanswered_calls: 'مكالمات دون رد',
  System_Trunk_errors: 'أخطاء النظام',
  Average_length_per_call: 'متوسط طول المكالمة',
  Calls_per_Hour: 'المكالمات لكل ساعة',
  Calls_by_Status: 'المكالمات حسب الحالة',
  Top_Extension_Volume: 'أعلى التحويلات استخداماً',
  Recent_Calls_Log: 'سجل المكالمات الأخيرة',
  Call_ID: 'معرف المكالمة',
  Caller: 'المتصل',
  Callee: 'المتلقي',
  Direction: 'الاتجاه',
  Duration: 'المدة',
  Actions: 'الإجراءات',
  Start_Time: 'وقت البدء',
  End_Time: 'وقت الانتهاء',
  Extension: 'التحويلة',
  Trunk: 'المسار (Trunk)',
  Active_Calls_Subtitle: 'مراقبة مكالمات البدالة المباشرة، وإدارة الجلسات النشطة، وتحويل المكالمات أو إنهاؤها في الوقت الفعلي',
  No_live_active_calls: 'لا توجد مكالمات نشطة حالياً.',
  State: 'الحالة',
  PBX_Extensions_Title: 'تحويلات البدالة (Extensions)',
  PBX_Extensions_Subtitle: 'إدارة تحويلات المستخدمين وحالتها وتفاصيل التسجيل والربط بالأقسام',
  Add_Extension: 'إضافة تحويلة',
  Registration_Status: 'حالة التسجيل',
  Registration: 'التسجيل',
  Email: 'البريد الإلكتروني',
  Call_Forward: 'تحويل المكالمات',
  Enable_Disable: 'تفعيل/تعطيل',
  Call_Forwarding_Subtitle: 'تكوين شروط تحويل المكالمات (دائماً، مشغول، لا يوجد رد، غير متاح) وتوجيه المكالمة لكل تحويلة',
  Forward_Type: 'نوع التحويل',
  Forward_Number: 'رقم التحويل',
  Inbound_Routes_Subtitle: 'إدارة أرقام الاتصال المباشر (DID)، وقواعد توجيه المكالمات الواردة (IVR، الطوابير، التحويلات)، وأولويات التنفيذ',
  Add_Inbound_Route: 'إضافة خط وارد',
  Route_Name: 'اسم الخط',
  DID_Pattern: 'الرقم المطلوب (DID) / النمط',
  Destination_Target: 'الوجهة المستهدفة',
  Priority: 'الأولوية',
  Outbound_Routes_Subtitle: 'إدارة أنماط الاتصال، وخطوط الربط (SIP Trunks) المعينة، وتجاوز معرف المتصل، وأولويات الاتصال الصادر',
  Add_Outbound_Route: 'إضافة خط صادر',
  Route: 'المسار',
  Dial_Pattern: 'نمط الاتصال',
  SIP_Trunk: 'خط SIP Trunk',
  Ring_Groups_Subtitle: 'تجميع تحويلات داخلية متعددة لتتصل معاً في نفس الوقت أو بشكل متسلسل',
  Add_Ring_Group: 'إضافة مجموعة اتصال',
  Group_Name: 'اسم المجموعة',
  Members: 'الأعضاء',
  Ring_Strategy: 'إستراتيجية الرنين',
  Call_Queues_Title: 'طوابير الاتصال (Queues)',
  Call_Queues_Subtitle: 'إدارة طوابير الاتصال وتوزيع المكالمات التلقائي، وتعيين الوكلاء، واستراتيجيات التوزيع والمكالمات في الانتظار',
  Add_Queue: 'إضافة طابور',
  Queue_Number: 'رقم الطابور',
  Queue_Name: 'اسم الطابور',
  Assigned_Agents: 'الوكلاء المعينون',
  Strategy: 'الإستراتيجية',
  Waiting_Calls: 'مكالمات في الانتظار',
  Call_Recordings: 'تسجيلات المكالمات',
  Call_Recordings_Subtitle: 'الاستماع إلى التسجيلات الصوتية المخزنة، وتنزيل ملفات WAV/MP3، وإدارة الاحتفاظ بالتخزين',
  Recording_Name: 'اسم التسجيل',
  Receiver: 'المستلم',
  Date_Time: 'التاريخ والوقت',
  File_Size: 'حجم الملف',
  Play_Recording: 'تشغيل التسجيل',
  Delete_File: 'حذف الملف',
  Delete_Call_Recording: 'حذف تسجيل المكالمة؟',
  Delete_Recording_Confirm: 'هل أنت متأكد من رغبتك في حذف ملف التسجيل نهائياً؟',
  Delete_Inbound_Route: 'حذف الخط الوارد؟',
  Delete_Inbound_Route_Confirm: 'هل أنت متأكد من رغبتك في إزالة هذا الخط الوارد؟',
  Delete_Outbound_Route: 'حذف الخط الصادر؟',
  Delete_Outbound_Route_Confirm: 'هل أنت متأكد من رغبتك في إزالة هذا الخط الصادر؟',
  Delete_Ring_Group: 'حذف مجموعة الاتصال؟',
  Delete_Ring_Group_Confirm: 'هل أنت متأكد من رغبتك في إزالة مجموعة الاتصال هذه؟',
  Delete_Call_Queue: 'حذف طابور الاتصال؟',
  Delete_Call_Queue_Confirm: 'هل أنت متأكد من رغبتك في إزالة هذا الطابور؟',
  Edit_Extension: 'تعديل التحويلة',
  Add_New_Extension: 'إضافة تحويلة جديدة',
  Extension_Number: 'رقم التحويلة',
  Full_Name: 'الاسم الكامل',
  Email_Address: 'البريد الإلكتروني',
  SIP_Secret: 'كلمة سر SIP',
  Save_Extension: 'حفظ التحويلة',
  Edit_Call_Forwarding: 'تعديل تحويل المكالمات',
  Forward_Target_Number: 'رقم/وجهة التحويل',
  Enable_Forwarding_Rule: 'تفعيل قاعدة التحويل',
  Save_Rule: 'حفظ القاعدة',
  Edit_Inbound_Route: 'تعديل الخط الوارد',
  Save_Route: 'حفظ الخط',
  Edit_Outbound_Route: 'تعديل الخط الصادر',
  Edit_Ring_Group: 'تعديل مجموعة الاتصال',
  Select_Extension_Members: 'اختر التحويلات الأعضاء:',
  Group_Extension: 'تحويلة المجموعة',
  Save_Group: 'حفظ المجموعة',
  Edit_Call_Queue: 'تعديل طابور الاتصال',
  Assign_Extension_Agents: 'تعيين وكلاء التحويلات:',
  Save_Queue: 'حفظ الطابور',
  Transfer_Active_Call: 'تحويل المكالمة النشطة',
  Transferring_call_from: 'تحويل المكالمة من',
  to_target_extension: 'إلى التحويلة المستهدفة.',
  Target_Extension_Number: 'رقم التحويلة المستهدفة',
  Transfer_Call: 'تحويل المكالمة',
  Call_Detail: 'تفاصيل المكالمة',
  Recording: 'التسجيل',
  No_Recording: 'لا يوجد تسجيل',
  Test_PBX_Connection: 'اختبار الاتصال بالبدالة',
  Refresh: 'تحديث',
  Export_CSV: 'تصدير CSV',
  Add_New: 'إضافة جديد',
  Clear: 'مسح',
  Search_Placeholder: 'بحث...',
  Confirm_Action: 'تأكيد الإجراء',
  Processing: 'جاري المعالجة...',
  Registered: 'مسجل',
  Unregistered: 'غير مسجل',
  Always: 'دائماً',
  Busy: 'مشغول',
  No_Answer: 'لا يوجد رد',
  Unavailable: 'غير متاح',
  RingAll: 'رنين للكل (في نفس الوقت)',
  Hunt: 'تسلسلي (Hunt)',
  Memory: 'دوري (Memory)',
  LeastRecent: 'الأقل استخداماً مؤخراً',
  Random: 'عشوائي',
  FewestCalls: 'الأقل مكالمات',
  Agents: 'الوكلاء',
  Waiting: 'في الانتظار',
  On: 'مفعل',
  Off: 'معطل',
  Answered: 'مجابة',
  Missed: 'فائتة',
  Failed: 'فاشلة',
  Last_7_Days_Calls: 'مكالمات آخر 7 أيام',
  This_Month_Calls: 'مكالمات هذا الشهر',
  Period_Calls: 'مكالمات الفترة المحددة',
  Total_processed_7days: 'إجمالي مكالمات آخر 7 أيام',
  Total_processed_month: 'إجمالي مكالمات هذا الشهر',
  Total_processed_period: 'إجمالي مكالمات الفترة المحددة',
};